<template>
    <div class="income-group-items-editor">
        <div>
            <div v-for="(header, index) in headers" :key="index" class="" :style="header.width === 'auto' ? { flex: 1 } : { width: header.width }">
                <div v-if="header.key === 'categories'" class="header">
                    <div>{{ header.label }}</div>
                </div>
                <div v-else class="header">
                    <div>{{ header.label }}</div>
                    <el-button
                        v-if="(header.key === 'groups' && isGroupAddable) || (header.key === 'items' && isItemAddable) || (header.key === 'groups-contrast' && isGroupAddable)"
                        size="small"
                        style="margin: -12px 10px -12px 0"
                        @click="onAdd(header.key, true)"
                    >
                        <i class="el-icon-plus" style="margin-right: 10px" />
                        新增
                    </el-button>
                </div>

                <div v-if="header.key === 'categories'" class="item-section">
                    <div
                        v-for="(data, index) in categoryList"
                        :key="`categoryItem${index}`"
                        class="item transition group-setting-category-list"
                        :class="{ active: activeCategory === data.key }"
                        @click="onChangeCategory(data.key)"
                    >
                        {{ data.value }}
                    </div>
                </div>

                <div v-if="header.key === 'groups'" class="item-section">
                    <GroupSettingView
                        v-model="groupList"
                        class="group-setting-group-list"
                        :onDragEnd="onDragEnd"
                        :onChange="onChangeGroup"
                        :onEdit="onGroupEdit"
                        :onAdd="() => onAdd(header.key)"
                        :add-show="isGroupAddable"
                        :active-sno="activeGroup"
                        :active-category="activeCategory"
                    />
                </div>

                <div v-if="header.key === 'items'" class="item-section">
                    <ItemSettingView
                        v-model="itemList"
                        class="group-setting-item-list"
                        :onDragEnd="onItemDragEnd"
                        :onEdit="onItemEdit"
                        :onAdd="() => onAdd(header.key)"
                        :add-show="isItemAddable"
                        :active-sno="activeItem"
                        :active-category="activeCategory"
                        :active-group-sno="activeGroup"
                        :isShowAccno="header.isShowAccno"
                        @addClick="onAdd(header.key)"
                        @update="$emit('updateData')"
                    />
                </div>

                <div v-if="header.key === 'groups-contrast'" class="item-section">
                    <GroupAnalysisSettingView
                        v-model="groupList"
                        :onDragEnd="onDragEnd"
                        :onEdit="onGroupEdit"
                        :onAdd="() => onAdd(header.key)"
                        :active-category="activeCategory"
                        @update="$emit('updateData')"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import { statementTypes } from '@/assets/commonData/options';
import GroupSettingView from './GroupSettingView.vue';
import ItemSettingView from './ItemSettingView.vue';
import GroupAnalysisSettingView from './GroupAnalysisSettingView.vue';

export default {
    components: { GroupSettingView, ItemSettingView, GroupAnalysisSettingView },
    props: {
        data: {
            type: Object,
            default: () => {},
        },
        initActiveCategory: {
            type: String,
            default: 'invoiceSettings',
        },
        headers: Array,
    },
    data() {
        return {
            isActiveGroupDisabled: false,

            activeCategory: this.initActiveCategory,
            activeGroup: '',
            activeItem: '',

            categoryList: [],
            groupList: [],
            itemList: [],
        };
    },
    computed: {
        isGroupAddable() {
            return !!this.activeCategory;
        },
        isItemAddable() {
            return !!this.activeGroup && !this.isActiveGroupDisabled;
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        initActiveCategory(newValue) {
            this.activeCategory = newValue;
            this.onChangeCategory(newValue, false);
        },
    },
    methods: {
        init() {
            this.categoryList = _.map(statementTypes, (o) => ({
                key: o.key,
                value: o.value,
                childSettings: this.data[o.key],
            }));
            if (this.activeCategory && !_.isEmpty(this.data)) {
                this.groupList = [...this.data[this.activeCategory]];
            }

            if (this.activeGroup) {
                this.itemList = _.find(this.groupList, ['sno', this.activeGroup])?.childSettings;
            }
        },

        onChangeCategory(key, fireEmit = true) {
            this.activeCategory = key;
            this.groupList = this.data[key];
            this.activeGroup = null;
            this.itemList = [];
            if (fireEmit) {
                this.$emit('onCategoryChange', key);
            }
        },
        onChangeGroup(key) {
            this.activeGroup = key;
            const found = _.find(this.groupList, ['sno', key]);
            this.itemList = found.childSettings;
            this.isActiveGroupDisabled = found.iS_SYS || !!found.copySno;
        },

        onDragEnd(newOrder) {
            const items = _.map(newOrder, (o, i) => ({ sno: o.sno, sot: i }));
            this.$emit('update', items);
        },
        onItemDragEnd(newOrder) {
            this.onDragEnd(newOrder);

            const foundIndex = _.findIndex(this.groupList, ['sno', this.activeGroup]);
            this.groupList[foundIndex].childSettings = [...newOrder];
        },
        onMove(e) {
            if (e.relatedContext.element.disabled) return false;
            return true;
        },

        onGroupEdit(data) {
            this.$emit('edit', {
                data,
                category: _.find(statementTypes, ['key', this.activeCategory]).type,
            });
        },
        onItemEdit(data) {
            this.$emit('edit', {
                data,
                group: this.activeGroup,
                category: _.find(statementTypes, ['key', this.activeCategory]).type,
            });
        },
        onAdd(key, isTop) {
            if (key === 'groups' || key === 'groups-contrast') {
                this.$emit('add', {
                    category: _.find(statementTypes, ['key', this.activeCategory]).type,
                    isTop,
                });
                return;
            }

            if (key === 'items') {
                this.$emit('add', {
                    group: this.activeGroup,
                    category: _.find(statementTypes, ['key', this.activeCategory]).type,
                    isTop,
                });
            }
        },
    },
};
</script>
<style lang="scss" scooped>
@import "@/assets/scss/vars.scss";

.income-group-items-editor {
    width: 100%;
    height: 61vh;
    > * {
        display: flex;
        width: 100%;
        height: 100%;
        margin: auto;
        box-sizing: border-box;

        > * {
            border: 2px solid #cccccc;
            border-right: 0px;
            display: flex;
            height: 100%;
            flex-direction: column;

            &:last-child {
                border-right: 2px solid #cccccc;
            }
        }
    }
    .header {
        color: #7a7a7a;
        font-size: 11pt;
        font-weight: 700;
        background-color: rgba(0, 0, 0, 0.03);
        padding: 12px 0;
        text-align: center;
        margin-bottom: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        div {
            margin: auto;
        }
        i {
            cursor: pointer;
            margin-right: 20px;
        }
    }

    .sub-header {
        padding: 0 35px 0 30px;
        display: flex;
        align-items: center;
        margin-bottom: 2px;
        justify-content: space-between;
        color: #888;
        font-size: 10pt;

        .description {
            display: flex;
            align-items: center;
            .combo {
                display: flex;
                > :first-child {
                    margin-right: 20px;
                }
            }
            .label {
                width: 195px;
                text-align: left;
            }
        }
    }

    .item-section {
        overflow-y: auto;
    }

    .item {
        cursor: pointer;
        padding: 10px 35px 10px 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 11pt;

        &:hover {
            background-color: rgb(70, 60, 178, 0.04);
        }

        &.active {
            position: relative;
            background-color: rgb(70, 60, 178, 0.1);
            &::before {
                content: "";
                position: absolute;
                background-color: #6f3dd9;
                height: 100%;
                width: 5px;
                top: 0;
                left: 0;
            }
        }
        &.disabled {
            color: #bfbfbf;
        }
        &.transition {
            transition: 0.2s;
        }

        .item-label {
            display: inline-block;
            margin-left: 7px;
            padding: 0px 4px;
            line-height: 20px;
            color: #aaa;
            font-size: 9pt;
            border: 1px solid #ccc;
            border-radius: 5px;
            white-space: nowrap;
        }
    }

    .handle {
        cursor: grab;
        position: relative;
        width: 25px;
        height: 20px;
        margin-right: 10px;
        > * {
            position: absolute;
            left: 6px;
            width: 13px;
            height: 2px;
            background-color: #ddd;
            transform: translateY(-50%);
            transition: 0.3s;
        }
        :nth-child(1) {
            top: calc(50% + 2.5px);
        }
        :nth-child(2) {
            top: calc(50% - 2.5px);
        }
        &:hover {
            > * {
                background-color: #6f3dd9;
            }
        }
        &.disabled {
            cursor: pointer;
        }
    }
    .edit-btn {
        cursor: pointer;
        width: 30px;
        height: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        > * {
            width: 3px;
            height: 3px;
            border-radius: 50%;
            background-color: #c4c4c4;
            margin-right: 3px;
            transition: 0.3s;
            &:last-child {
                margin-right: 0;
            }
        }

        &:hover {
            > * {
                background-color: #6f3dd9;
            }
        }
    }

    .button-wrapper {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        padding: 10px 18px;
        > * {
            color: #bfbfbf !important;
        }
    }
}
</style>
